<his-plam label="{{label | hisUi}}"
		  [helptext]="configuration?.helptextIcon | hisUi"
		  [required]="required"
		  renderLabelAsDiv
		  #internalPlam>

	<his-file-upload #content
					 [configKey]="configKey"
					 [(ngModel)]="model"
					 [disabled]="configuration?.readonly"
					 [required]="required">
	</his-file-upload>
</his-plam>
